import { render, staticRenderFns } from "./CourseVimeo.vue?vue&type=template&id=3ff5a000&scoped=true&"
import script from "./CourseVimeo.vue?vue&type=script&lang=js&"
export * from "./CourseVimeo.vue?vue&type=script&lang=js&"
import style0 from "./CourseVimeo.vue?vue&type=style&index=0&id=3ff5a000&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff5a000",
  null
  
)

component.options.__file = "CourseVimeo.vue"
export default component.exports